import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

import { configFlux, dataConfigFlux } from "./graph-flux";

const graphFlux = [
  {
    id: "flux",
    dataConfig: dataConfigFlux,
    options: configFlux,
    plugins: ChartDataLabels,
    element: Bar,
    className: "col-span-1 lg:col-span-2 w-full h-[400px]",
  },
];

export default graphFlux;
